// api path
const HTTP_URL = {
  authNeed: 'common/auth_need', // 授权
  getUserInfo: 'user/user_info',
  userInfoV2: 'user/user_info_v2',
  submitInvoice: 'order/add_invoce',
  tracing: 'common/tracing', // 埋点
  getHotPackage: 'api/get_hot_package',
  getOrgList: 'org/list',
  getOrgBrowse: 'org/browse',
  getHospitalTags: 'api/get_hospital_tags',
  getRecommendOrg: 'api/get_org_list',
  getRecommendHospital: 'Org/suggest',
  getWellChosenPackage: 'Package/well_chosen_list',
  getCityList: 'city/qqindex',
  getCategory: 'api/get_category',
  getPackagesListByCate: 'api/get_packages_list_by_cate',
  getPackagesList: 'api/get_packages_list_by_cate',
  get58PackagesList: 'exam58/PackagesList',
  getHotkey: 'api/search_words_common',
  getSearchList: 'api/search',
  getPackagesListActivity: 'api/act_package_list',
  search: 'api/search',
  createOrder: 'medicalcard/create_order',
  getFamilyDetial: 'api/get_family',
  saveMemeber: 'api/save_member',
  orderBookingDate: 'api/order/orderBookingDate',
  deleteMemeber: 'api/delete_member',
  getCoupons: 'api/get_coupons',
  getFamily: 'user/familes',
  feedback: 'user/feedback',
  saveInvoice: 'order/invoce',
  getReportLink: 'user/report_link',
  getAllReportList: 'user/all_report_list',
  getRandCode: 'user/get_rand_code',
  verifyPicCode: 'common/pic_code_check',
  userRegister: 'user/register',
  getTags: 'api/get_tags',
  getCardTags: 'package/tags',
  bianlaDetail: 'package/detail',
  getPackageItemsByIds: 'api/get_package_items_by_ids',
  getPackageDetail: 'api/get_package_detail',
  oldOrgDetail: 'org/org_detail',
  getOrgDetail: 'org/new_org_detail',
  getApplySchedule: 'org/schedule_format',
  getNewApplySchedule: 'basicInfo/scheduleFormat',
  orgDetailWithOrder: 'org/org_detail_with_order',
  CouponAndDmi: 'coupon',
  applyPackageCount: 'package/package_count',
  applyPackageDetails: 'package/package_details',
  applyReserve: 'order/reserve',
  applyReserveV2: 'order/placeOrder',
  reserveBefore: 'order/reserveBefore',
  applyReport: 'org/report',
  activityHandle: 'activity/handle',
  activityRandCode: 'user/get_activity_rand_code',
  insuranceList: 'user/insurance_list',
  insuranceDetail: 'user/insurance_detail',
  clearSearchHistory: 'api/clearHistory',
  locate_by_lon_lat: 'common/locate_by_lon_lat',
  wechatminiPay: 'order/wechatminiPay',
  scheduleTimes: 'org/schedule_times',
  saveMedicalInvoice: 'medicalcard/invoice',
  addCardInvoice: 'medicalcard/addInvoice',
  medicalcardInfo: 'medicalcard/confirmOrder',
  medicalcardOrders: 'medicalcarduser/orders',
  medicalcardOrderDetail: 'medicalcard/order',
  medicalcardExchange: 'medicalcard/exchangeNew',
  cardPayAfter: 'medicalcard/pay_success',
  orderDetail: 'order/detail_v2',
  getCardOrder: 'medicalcard/order_info',
  deleteCardOrder: 'medicalcard/delOrder',
  cancelCardOrder: 'medicalcard/cancelOrder',
  getPackageList: 'api/get_package_list',
  getCardCityList: 'medicalcard/support_cities',
  getCardDetail: 'medicalcard/card_detail',
  getCardPackageList: 'medicalcard/package_list',
  getOrgPackageList: 'medicalcard/org_package_list',
  medicalcardRefund: 'medicalcard/refund',
  medicalCardGift: 'Medicalcarduser/cardGift',
  medicalCardReceive: 'Medicalcarduser/receiveGift',
  medicalcardSupport: 'medicalcard/support',
  medicalCardOrders: 'medicalcard/orders',
  medicalcardOrderSimple: 'medicalcard/orderSimple',
  medicalcardNewCardId: 'Medicalcarduser/newCardId',
  packageContrast: 'package/contrast',
  getTheEarliestDate: 'org/schedule_format',
  reportList: 'report/list',
  reportSelfList: 'report/reportSelfList',
  reportSelfDetail: 'report/reportSelfDetail',
  reportSelfDel: 'report/reportSelfDel',
  reportSendEmail: 'report/reportSendEmail',
  articleList: 'Article/articleList',
  articleDetail: 'Article/detail',
  packageCompare: 'package/packageCompare',
  addPackageCompare: 'package/addPackageCompare',
  remPackageCompare: 'package/remPackageCompare',
  addCollect: 'collect/add',
  collectList: 'collect/list',
  cancelCollect: 'collect/cancel',
  likeArticle: 'article/isUseful',
  articleTags: 'article/tags',
  articleComment: 'article/comment',
  packageBrowseList: 'package/packageBrowseList', // 套餐历史
  remPackageBrowse: 'package/remPackageBrowse', // 删除套餐历史
  cachePackageBrowse: 'package/cachePackageBrowse', // 同步套餐登陆前后浏览历史
  requirement: 'requirement', // 企业咨询合作接口
  userCenterMeassage: 'user/userCenterMeassage', // 个人中心未读消息
  isSeeMessage: 'user/isSeeMessage', // 将未读消息设置为已读
  getAbleCoupon: 'coupon',
  homePopub: 'home/popub', // 首页活动弹窗
  getCouponsAll: 'api/get_coupons_all',
  myCoupons: 'coupon/my_list',
  customerQList: 'customerservice/questionList',
  customerAns: 'customerservice/getAnswer',
  customerRate: 'customerservice/rate',
  dmiRecord: 'user/dmiUsageRecord',
  dmiList: 'usercenter/dmiCardDetails',
  dmiInfo: 'user/dmi_handle',
  // dmiInfo: 'usercenter/dmi_handle',
  taifuliInfo: 'home/taifuli',
  isPartnerCodeValid: 'partner/isPartnerCodeValid',
  getExcluiveOffer: 'order/get_excluive_offer',
  offerDetails: 'order/offer_details',
  check_user_order: 'api/check_user_order', // 检查用户订单
  bookingNotice: 'basicInfo/bookingNotice', // 体检须知
  cardDetails: 'medicalcard/cardDetails', // 体检卡详情
  familyDoctorLoginUrl: 'familydoctor/loginurl', // 家庭医生首页+个人中心页面跳转
  familyDoctorHasFamilyDoc: 'familydoctor/hasFamilyDoc', // 查询当前用户是否有家庭医生权益
  familyDoctorCardexchange: 'familydoctor/cardexchange', // 医生卡兑换接口
  timePeriod: 'basicInfo/timePeriod', // 时间段
  confirmationOrder: 'familydoctor/confirmationOrder', // 家庭医生卡卡详情
  familydoctorAfterSale: 'familydoctor/afterSale', // 家庭医生卡退款查询
  purchased: 'familydoctor/purchased', // 查询当前用户是否已成功购买医生卡
  familyDoctorCreateOrder: 'familydoctor/create_order', // 医生卡提交订单
  familyDoctorOrder: 'familydoctor/order', // 医生卡详情接口
  familyDoctorDescCarNum: 'familydoctor/descCarNum',
  familydDoctorRefund: 'familydoctor/refund', // 医生卡申请售后接口（退款接口）
  familydoctorGetBenefit: 'familydoctor/getBenefit', // 查询当前用户权益接口
  familydoctorCenter: 'familydoctor/userCenter', // 家庭医生用户中心会员接口
  familydoctorTransfer: 'familydoctortransfer/transfer', // 家庭医生分享转赠页面接口
  familydoctorShare: 'familydoctortransfer/share', // 家庭医生获取转赠密文接口
  familydoctorReceive: 'familydoctortransfer/receive', // 家庭医生领取转赠页面接口
  familydoctorAccept: 'familydoctortransfer/accept', // 家庭医生确认领取医生卡接口
  familydoctorOrderList: 'familydoctor/orderList', // 家庭医生购买记录列表接口
  familydoctorSelfCardExchange: 'familydoctor/selfCardExchange ', // 流程优化过的 好医生卡激活
  loginInfo: 'customization/loginInfo',
  shareCompany: 'user/shareCompany', // 疫情分享
  userGetData: 'user/getData', // 分享计数
  addReport: 'report/reportSelf',

  cardList2: 'partner/doctor_card_list', // 好医生卡列表
  doctorLayout: 'partner/doctor_layout', // 个人中心列表

  familydoctorCanCelOrder: 'familydoctor/canCelOrder', //好医生卡 / 经纪人项目的健康卡  取消订单
  familydoctorConfirmReceipt: 'familydoctor/confirmReceipt', //好医生卡 / 经纪人项目的健康卡  确认收货
  familydoctorSelTrack: "familydoctor/selTrack", //好医生卡 / 经纪人项目的健康卡  查看物流


  plusProductAll: 'plusProduct/all',
  plusOrderIndex: 'plusOrder/index',
  plusOrderCreate: 'plusOrder/create',
  plusOrderDetail: 'plusOrder/detail',
  plusOrderPay: 'plusOrder/pay',
  plusOrderRefund: 'plusOrder/refund',
  plusOrderCancel: 'plusOrder/cancel',
  plusProductHasBuyTj: 'plusProduct/hasBuyTj',
  plusOrderCoupons: 'plusOrder/coupons',
  plusProductDetail: 'plusProduct/detail',
  // 拼团
  getGropBuyList: 'package/getGropBuyList',
  getPackageGroupBuyInfo: 'package/getPackageGroupBuyInfo',
  getPackageListGroupBuy: 'api/getPackageListGroupBuy',
  getOrgListGroupBuy: 'api/getOrgListGroupBuy',
  getGroupBuyTopList: 'api/get_group_buy_top_list',
  pointList: 'UserPointChange/index',
  getByAreaCode: "city/get_by_area_code",


  //西丽人名医院 送优惠券
  org_send_coupon: 'api/org_send_coupon',


  //端午节活动新增接口
  festivalHotsearch: 'Festival/hotsearch',
  festivalBanner: 'Festival/banner',

  // 通用工具接口
  generateQRCode: 'tool/qrcode',
  uploadImg: 'Common/uploadImg',

  // 新个人中心接口
  userCenterCouponCount: "UserCenter/coupon_count",
  UserCenteIsVip: "UserCenter/is_vip",

  // 【SEO优化】广告渠道全链路数据追踪
  seoVisitLog: "seo/visitLog",
  // 口袋跳转 城市名获取id
  pocketEntryExamPackage: "package/pocketEntryExamPackage",

  // 预付卡相关接口
  getMallCardList: "AgentCard/mallCardList",
  getPrepaidCardList: "familydoctor/orderList",
  createCardOrder: "Familydoctor/create_order",
  activePrepaidCard: "familydoctor/selfCardExchange",
  getCardDealDetail: "familydoctor/userCardDetail",
  getMallCardDetail: "AgentCard/mallCardDetail"
}
export default HTTP_URL
